import { connect } from 'react-redux';

import {
  getCurrentRepository,
  getRepositoryDetails,
  getSizeLimits,
} from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import fetchRepositoryDetails from '../actions/fetch-repository-details';
import toggleSyncDialog from '../actions/toggle-sync-dialog';
import RepositoryDetailsCard from '../components/repository-details-card';

const mapStateToProps = (state: BucketState) => ({
  ...getRepositoryDetails(state),
  repository: getCurrentRepository(state),
  sizeLimits: getSizeLimits(state),
});

// @ts-ignore TODO: fix noImplicitAny error here
const mapDispatchToProps = dispatch => ({
  onOpenSyncDialog: () => dispatch(toggleSyncDialog(true)),
  onErrorClick: (repositoryFullSlug: string) =>
    dispatch(fetchRepositoryDetails(repositoryFullSlug)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore lastUpdated is typed as Date but will get a string
)(RepositoryDetailsCard);
